import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const foodDialog = [
  new Dialog(
    "SONNY YANG: Ahh my Can of Food from the Supermarket! You’re a sight for sore eyes!",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-52-Sonny-MP3.mp3")
  ),
  new Dialog(
    "Acquired 1 x LAST CAN OF FOOD",
    require("@/images/Can_of_Food.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];

export class DarethsKitchen extends Scene {
  title = "Dareth's Kitchen";
  async init() {
    this.description = "";
    this.image = require("@/images/Dareths_Kitchen.png");
    this.audio = null;
  }
  get options(): any[] {
    return [
      new Choice("Look in Cupboard", async () => {
        if (this.state.inventory.beans.has) {
          this.audio = require("@/audio/Pandemic-53-Sonny-MP3.mp3");
          this.description =
            "SONNY YANG: I’ve already taken what’s rightfully mine.";
        } else {
          this.init();
          await this.dialogRunner(foodDialog)
          this.state.inventory.beans.has = true;
          if (this.state.inventory.toiletPaper.has) {
            await this.navigate(scenes.ConfrontDareth());
          }
        }
      }),
      new Choice("Look in Fridge", () => {
        this.description =
          "SONNY YANG: Nothing in here except an assortment of artisanal meats.";
        this.audio = require("@/audio/Pandemic-54-Sonny-MP3.mp3");
      }),
      new Choice("Go Back", async () => await this.navigate(scenes.DarethsFoyer())),
    ];
  }
}

export default new DarethsKitchen();
